import {CommercialProductType} from 'types/commercial-product-type';

export const commercialProductTypes = [
  'PRODUCT',
  'EXTERNAL_PRODUCT',
  'TITLE',
  'SUBTITLE',
] as CommercialProductType[];
